module.exports = __webpack_public_path__ + "static/media/intro-1.e84ba70d.png";